import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React__default, { useState, useEffect } from 'react';
import useSendbirdStateContext from '../useSendbirdStateContext.js';
import { U as UserProfileProvider } from '../UserProfileContext-f3f446d2.js';
import { u as uuidv4 } from '../uuid-717930b4.js';
import '../withSendbird.js';
import '../_rollupPluginBabelHelpers-05128ded.js';
import 'prop-types';
var ChannelSettingsContext = /*#__PURE__*/React__default.createContext(undefined);
var ChannelSettingsProvider = function ChannelSettingsProvider(props) {
  var _props$disableUserPro;
  var children = props.children,
    className = props.className,
    channelUrl = props.channelUrl,
    onCloseClick = props.onCloseClick,
    onLeaveChannel = props.onLeaveChannel,
    onChannelModified = props.onChannelModified,
    overrideInviteUser = props.overrideInviteUser,
    onBeforeUpdateChannel = props.onBeforeUpdateChannel,
    queries = props.queries; // fetch store from <SendbirdProvider />
  var globalStore = useSendbirdStateContext();
  var config = globalStore.config,
    stores = globalStore.stores;
  var sdkStore = stores.sdkStore;
  var logger = config.logger,
    onUserProfileMessage = config.onUserProfileMessage;
  var initialized = sdkStore.initialized;
  var sdk = sdkStore === null || sdkStore === void 0 ? void 0 : sdkStore.sdk;

  // hack to keep track of channel updates by triggering useEffect
  var _useState = useState(uuidv4()),
    _useState2 = _slicedToArray(_useState, 2),
    channelUpdateId = _useState2[0],
    setChannelUpdateId = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    channel = _useState4[0],
    setChannel = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    invalidChannel = _useState6[0],
    setInvalidChannel = _useState6[1];
  var forceUpdateUI = function forceUpdateUI() {
    setChannelUpdateId(uuidv4());
  };
  useEffect(function () {
    logger.info('ChannelSettings: Setting up');
    if (!channelUrl || !initialized || !sdk) {
      logger.warning('ChannelSettings: Setting up failed', 'No channelUrl or sdk uninitialized');
      setInvalidChannel(false);
    } else {
      if (!sdk || !sdk.groupChannel) {
        logger.warning('ChannelSettings: No GroupChannel');
        return;
      }
      sdk.groupChannel.getChannel(channelUrl).then(function (groupChannel) {
        if (!groupChannel) {
          logger.warning('ChannelSettings: Channel not found');
          setInvalidChannel(true);
        } else {
          logger.info('ChannelSettings: Fetched group channel', groupChannel);
          setInvalidChannel(false);
          setChannel(groupChannel);
        }
      });
    }
  }, [channelUrl, initialized, channelUpdateId]);
  return /*#__PURE__*/React__default.createElement(ChannelSettingsContext.Provider, {
    value: {
      channelUrl: channelUrl,
      onCloseClick: onCloseClick,
      onLeaveChannel: onLeaveChannel,
      onChannelModified: onChannelModified,
      onBeforeUpdateChannel: onBeforeUpdateChannel,
      queries: queries,
      overrideInviteUser: overrideInviteUser,
      setChannelUpdateId: setChannelUpdateId,
      forceUpdateUI: forceUpdateUI,
      channel: channel,
      invalidChannel: invalidChannel
    }
  }, /*#__PURE__*/React__default.createElement(UserProfileProvider, {
    renderUserProfile: props === null || props === void 0 ? void 0 : props.renderUserProfile,
    disableUserProfile: (_props$disableUserPro = props === null || props === void 0 ? void 0 : props.disableUserProfile) !== null && _props$disableUserPro !== void 0 ? _props$disableUserPro : config === null || config === void 0 ? void 0 : config.disableUserProfile,
    onUserProfileMessage: onUserProfileMessage
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-channel-settings ".concat(className)
  }, children)));
};
var useChannelSettingsContext = function useChannelSettingsContext() {
  return React__default.useContext(ChannelSettingsContext);
};
export { ChannelSettingsProvider, useChannelSettingsContext };